<div class="box">
  <div class="box-row header">
    <app-header-bar [title]="'workflow.default.title'"></app-header-bar>
  </div>
  <div class="box-row content mt-2">
    <div class="row w-100">
      <app-datatable [dataSource]="source"
                    [columns]="columns"
                    [identifier]="'default-workflows'"
                    [iconActions]="iconActions"
                    (showEvent)="show($event.valueOf())"
                    (newEvent)="new()">
                      <app-empty-table [icon]="'rebase'"
                        [emptyText]="'workflow.default.empty_text' | translate"
                        [buttonText]="'createNew' | translate"
                        (btnClick)="new()">
                    </app-empty-table>
      </app-datatable>

      <app-error [error]="error"></app-error>

      <app-model-modal #EditModal (saveEvent)="onSave()">
        <app-workflow-template-form #form (closeEvent)="onModalClose()" (loadingEvent)="onLoading($event.valueOf())"></app-workflow-template-form>
      </app-model-modal>
    </div>
  </div>
</div>
